import { tierObject } from '@constants/index';
import { RootState, Tier } from '@utils/types';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const TierBadge = () => {
  const { t: translate } = useTranslation();
  const { tier } = useSelector((state: RootState) => state.user);

  const tierValue: Tier = tierObject[tier as keyof typeof tierObject];

  return <span className={tierValue.class}>{translate(tierValue.title)}</span>;
};

export default TierBadge;
